export default () => {
  const data = {
    event_name: 'click',
    button_name: 'banner_balneario',
    page_section: 'banner_balneario',
    name_of_the_page_viewed: 'development_list_personal',
  };
  return data;
};
